<div>
  <div *ngIf="recording" class="flex">
    <audio controls class="flex-grow-1">
        <source src="{{getRecordingUrl()}}" type="audio/mpeg">
        Tu navegador no soporta reproducción de audio
    </audio>
  </div>

  <p-card header="Transcripción Completa" styleClass="mt-4">
    {{transcriptionText}}
  </p-card>
  
  <p-card header="Transcripción Segmentada" styleClass="mt-4">
    <div class="flex flex-column gap-2">
      <div *ngFor="let segment of transcriptionSegments" class="segment flex gap-1">
        <span class="speaker" [class]="'speaker-' + segment.speaker">{{segment.speaker}}</span>
        {{segment.text}}
      </div>
    </div>
  </p-card>
</div>